module.exports = __webpack_public_path__ + "media/assets/good_at/python-37d2b29995680607b0b839a401379835.png";